import { createSlice } from "@reduxjs/toolkit";

const chatbotSlice = createSlice({
    name: "chatbot",
    initialState: {
        show_chatbot_widget: false,
        random_session_id: '',
        chat_message: [],
        user_data: {},
        user_feedback_popup: false,
        session_logout: false,
        logout_from: '',
    },
    reducers: {
        userLoggedInShowChatbot(state, action) {
            const { from, chatbot_widget, data, Logged_in_show_chatbot } = action.payload;
            let show_chatbot_widget = chatbot_widget || false;
            let user_data = data || state.user_data || {};

            if (from === "employer") {
                if (action.payload?.data?.payment_status === "trialing") show_chatbot_widget = false;
            }
 
            state.Logged_in_show_chatbot = Logged_in_show_chatbot || false;
            state.show_chatbot_widget = show_chatbot_widget;
            state.random_session_id = '';
            state.chat_message = [];
            state.chat_input = '';
            state.user_data = user_data;
        },
        updateUserData(state, action) {
            if (typeof action.payload === "string") {
                state.logout_from = action.payload;
                state.session_logout = true;
            }
            else state.user_data = action.payload;
        },
        call_chatbot_api(state, action) {
            const { type, data, show } = action.payload;
            let existing_chat_messages = data?.flag === "init" ? [] : [...state?.chat_message];
            let update_chat_messages = []

            switch (type) {
                case 'minimize_chatbot':
                    state.minimize_chatbot = show;
                    state.show_chatbot_widget = !show;
                    break;

                case 'call_chatbot_request':
                    if (data?.flag === 'step') existing_chat_messages.push({ conversation_by: 'user', message: data?.msg });
                    const if_dumbledoor_working_on_request = existing_chat_messages.some(item => item?.conversation_by === 'bot' && item?.is_dumbledoor_thinking === true);
                    if (!if_dumbledoor_working_on_request) existing_chat_messages.push({ conversation_by: 'bot', is_dumbledoor_thinking: true });

                    state.user_feedback_popup = data?.flag === "init" ? false : state?.user_feedback_popup
                    state.random_session_id = data?.flag !== "close" ? data?.session_id : null
                    state.chat_message = data?.flag !== "close" ? existing_chat_messages : []
                    state.show_chatbot_widget = data?.show_chatbot_widget
                    state.getting_chatbot_response = true
                    state.chat_input = ''
                    state.Logged_in_show_chatbot = false
                    break;

                case 'call_chatbot_response':
                    if (data?.message !== "Your chat has been closed.") update_chat_messages = [...existing_chat_messages.filter(item => item?.is_dumbledoor_thinking !== true), { conversation_by: 'bot', is_dumbledoor_thinking: false, message: data?.message }];
                    else update_chat_messages = [...existing_chat_messages.filter(item => item?.is_dumbledoor_thinking !== true)];

                    state.chat_message = update_chat_messages
                    state.getting_chatbot_response = false
                    state.user_feedback_popup = false
                    if (data?.message !== "Your chat has been closed.") state.Logged_in_show_chatbot = null
                    if (state.logout_from) {
                        state.logout_from = '';
                        state.session_logout = false;
                    }
                    break;

                case 'call_chatbot_failure':
                    update_chat_messages = [...existing_chat_messages.filter(item => item?.is_dumbledoor_thinking !== true)];
                    state.chat_message = update_chat_messages
                    state.getting_chatbot_response = false
                    state.user_feedback_popup = false
                    break;

                default:
                    return state;
            }
        },
        feedback_popup(state, action) {
            state.user_feedback_popup = action.payload;
            state.chat_input = '';
            state.chat_rating = 0;
        },
        chat_onchange_input(state, action) {
            state.chat_input = action.payload;
        },
        chat_rating(state, action) {
            state.chat_rating = action.payload;
        },
        show_chatbot_widget(state, action) {
            state.show_chatbot_widget = action.payload
        },
        resetChatbotState(state, action) {
            const { logout_from } = action.payload;

            if (logout_from) {
                state.logout_from = '';
                state.session_logout = false;
                state.user_data = {}
            }
        }
    }
})

const { actions, reducer } = chatbotSlice

export const {
    updateUserData, call_chatbot_api, feedback_popup,
    chat_onchange_input, chat_rating, userLoggedInShowChatbot,
    show_chatbot_widget, resetChatbotState
} = actions;

export default reducer;